import { LucideProps } from "lucide-react"

export const FAQIcons = {
  plus: (props: LucideProps) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      className="transition-transform duration-300"
      // style={{
      //   transform: expanded === index ? "rotate(45deg)" : "rotate(0)",
      // }}
    >
      <path
        d="M8 12.7998H12M16 12.7998H12M12 12.7998V8.7998M12 12.7998V16.7998"
        stroke="#030712"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 22.7998C17.5228 22.7998 22 18.3227 22 12.7998C22 7.27696 17.5228 2.7998 12 2.7998C6.47715 2.7998 2 7.27696 2 12.7998C2 18.3227 6.47715 22.7998 12 22.7998Z"
        stroke="#030712"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
}
